import { SelectWrapper } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/components/SelectWrapper';
import { ActionDropdown } from 'src/components/ActionDropdown/ActionDropdown';
import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    FilteredCollection,
    LiabilitiesFiltersProps,
} from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/LiabilitiesFilters.types';

type SportsFilterPropsType = Pick<LiabilitiesFiltersProps, 'onChange'> & {
    sport?: string | null;
    sports: FilteredCollection;
    editSport: (sport: { id: string | number; name?: string }) => void;
};

export const SportsFilter = observer(
    'SportsFilter',
    ({ onChange, sports, editSport, sport }: SportsFilterPropsType): JSX.Element => {
        const handleChange = (sport: unknown): void => {
            if (typeof sport === 'string' || sport === null) {
                onChange('sport', sport);
            }
        };
        const getAddForm = (): string => "Can't add sport (API needed)";
        const title = 'Sport';

        return (
            <div className='col-2'>
                <SelectWrapper label={title}>
                    <ActionDropdown
                        label={title}
                        name={title}
                        options={sports}
                        searchable
                        clearable
                        ignoreCase
                        onEdit={editSport}
                        value={sport}
                        onChange={handleChange}
                        className='dropdown-select-form'
                        getAddForm={getAddForm}
                        isShorten={true}
                    />
                </SelectWrapper>
            </div>
        );
    }
);
